import React, { Component } from 'react';
import { EUIPage } from '../EUI/EUIPage';
import { Immocom } from '../../specifique/immocom';

export class Mandat extends Component {

    constructor(props) {
        super(props);
        this.state = { monCompte: {} };
    };

    componentDidMount = () => {
        Immocom.chargementMonCompte(this);
    };

    render = () => {
        const affichageLienMandatSociete = this.state.monCompte.droitAccesFormulaireMandatSociete || this.state.monCompte.estExterne || this.state.monCompte.estReseau;
        const affichageLienMandatEiffage = this.state.monCompte.droitAccesFormulaireMandatEiffage || this.state.monCompte.estInterne;
        const affichageLienMandatWS = this.state.monCompte.droitAccesFormulaireMandatWS;

        return <EUIPage
            baseUrl="/Mandat"
            onglets={[
                { url: "/ListeMandatsSociete/Type/Societe", titre: "Société", hidden: !affichageLienMandatSociete },
                { url: "/ListeMandatsEiffage/Type/Eiffage", titre: "Eiffage", hidden: !affichageLienMandatEiffage },
                { url: "/ListeMandatsWS/Type/WS", titre: "WS", hidden: !affichageLienMandatWS },
                { url: "/GestionAlertes", titre: "Gestion des alertes" },
            ]}
        />;
    };

}